export default __webpack_public_path__ + "static/13-8fc3aad305da9646d2a6ba4e26850a7b.png";